import type { I18nStrings } from './types'

export const en: I18nStrings = {
  brand: 'ResearchFlow Forge',
  nav: {
    home: 'Home',
    skills: 'Skills',
    workflows: 'Workflows',
    gallery: 'Gallery',
    guide: 'Guide',
    language: 'EN / 中文',
  },
  home: {
    badge: 'Academic Toolbench V0 Live',
    title: 'One Forge.\nAll Research Skills.',
    subtitle:
      'A sophisticated command center for academics and technical architects. Curate specialized research skills, compose complex workflows, and generate secure installation commands with precision.',
    browseSkills: 'Browse Skill Catalog',
    exploreWorkflows: 'Explore Workflows',
    stats: {
      repos: 'References',
      skills: 'Skills',
      workflows: 'Workflows',
    },
    features: {
      title: 'Precision Instruments',
      subtitle: 'Everything required to build and deploy academic agents.',
      catalog: {
        title: 'Skill Catalog',
        desc: 'Access a curated set of agent skills, from data synthesis to literature parsing, designed for rigorous academic standards.',
      },
      workflow: {
        title: 'Workflow Templates',
        desc: 'Pre-configured architectural patterns for common research methodologies.',
      },
      builder: {
        title: 'Install Command Builder',
        desc: 'Generate precise, secure CLI commands tailored to your specific environment and skill selection.',
      },
      gallery: {
        title: 'Visual Gallery',
        desc: 'Explore visual outputs and data visualization patterns generated by community workflows.',
      },
    },
  },
  catalog: {
    title: 'Skill Catalog',
    subtitle:
      'Discover and integrate specialized academic and scientific skills into your local forge environment.',
    searchPlaceholder: 'Search skills, packages, or authors...',
    categories: {
      workflow: 'Workflow & Process',
      writing: 'Writing & Polishing',
      research: 'Research & Science',
      figures: 'Figures & Visuals',
      compute: 'Compute & Environment',
    },
    sourceRepo: 'Source Repo',
    addToCommand: 'Add to Command',
    added: 'Added',
    noResults: 'No skills match your search.',
  },
  workflows: {
    title: 'Research Missions',
    subtitle:
      'Select a pre-configured workflow template to rapidly instantiate complex research automations. These missions combine multiple academic skills into cohesive pipelines.',
    estSteps: 'Est. Steps',
    recommendedSkills: 'Recommended Skills',
    selectWorkflow: 'Select Workflow',
    selected: 'Selected',
    details: 'Details',
    complexity: {
      low: 'Low Complexity',
      medium: 'Medium Complexity',
      high: 'High Complexity',
    },
  },
  workflowDetail: {
    advancedWorkflow: 'Advanced Workflow',
    highComplexity: 'High Complexity',
    instantiate: 'Instantiate Workflow',
    saveToLibrary: 'Save to Library',
    executionPathway: 'Execution Pathway',
    requiredSkills: 'Required Skills',
    expectedOutputs: 'Expected Outputs',
    limitations: 'Limitations & Attribution',
  },
  gallery: {
    title: 'Scientific Visualizations',
    subtitle:
      'Explore a curated collection of high-fidelity diagrams, multi-panel nature-style figures, and complex AI workflow maps generated by ResearchFlow Forge skills.',
    copyPrompt: 'Copy Prompt',
    copied: 'Copied',
    skill: 'Skill',
    mockNote: 'Mock visualization for portfolio demonstration.',
  },
  installer: {
    title: 'Forge Installer',
    subtitle: 'Build your automation',
    commandBuilder: 'Command Builder',
    selectedItems: 'Selected Items',
    platformSelector: 'Platform Selector',
    targetPlatform: 'Target Platform',
    targetTool: 'Target Tool',
    macLinux: 'macOS / Linux',
    windowsWsl: 'Windows (WSL)',
    generatedCommand: 'Generated Command',
    copyRun: 'Copy & Run',
    advanced: 'Advanced',
    documentation: 'Documentation',
    github: 'GitHub',
    emptyState:
      'Select a workflow mission or skill from the canvas to begin forging your automation pipeline.',
    selectedSkills: 'Selected skills',
    selectedWorkflow: 'Selected workflow',
    mockDisclaimer:
      'V0 uses mock commands. Third-party repositories are referenced with attribution. This is not an official mirror.',
    copied: 'Copied',
  },
  footer: {
    copyright: '© 2024 ResearchFlow Forge. AcademicForge & Scientific Agent Skills.',
    documentation: 'Documentation',
    githubRepo: 'GitHub Repo',
    attribution: 'Attribution',
    privacy: 'Privacy',
  },
  common: {
    en: 'EN',
    zh: '中文',
  },
}
